module.exports = __webpack_public_path__ + "img/ring_y_l_0_1@2x.22a61ee8.png";